const links = document.querySelectorAll(".footer__quicklinks a");


links.forEach(link => {
    const isExternal = link.hostname && link.hostname !== window.location.hostname;

    if (isExternal) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
    }
});